import { CardRow } from 'components/CardRow';
import { navigateScreenAware } from 'components/Navigation/navigationRef';
import { Screens, Stacks } from 'components/Navigation/types';
import { useScreenSize } from 'hooks/useScreenSize';
import { useSelector } from 'hooks/useSelector';
import { ScreenSize } from 'lib/constants';
import { pluraliseS } from 'lib/pluralise';
import { theme } from 'lib/theme';
import React from 'react';
import {
  selectAseExplorerOptionShowValidationErrors,
  selectAseExplorerOptionSize,
  selectAseFieldGroupRequiredFieldValues,
  selectAseTplFieldGroup,
} from 'store/assessments/selectors';

export const ExplorerFieldGroupRow: React.FC<{
  groupId: string;
}> = ({ groupId }) => {
  const screenSize = useScreenSize();
  const group = useSelector((state) => selectAseTplFieldGroup(state, groupId));
  const requiredFieldValues = useSelector((state) =>
    selectAseFieldGroupRequiredFieldValues(state, groupId),
  );
  const showValidationErrors = useSelector(
    selectAseExplorerOptionShowValidationErrors,
  );
  const explorerOptionSize = useSelector(selectAseExplorerOptionSize);
  if (!group) {
    return null;
  }
  return (
    <CardRow
      key={group.id}
      label={group.name}
      label2Style={{ color: theme.colors.fieldValueText }}
      labelAlignTop
      value={
        requiredFieldValues && showValidationErrors
          ? pluraliseS(requiredFieldValues, 'incomplete field')
          : ''
      }
      valueColor={theme.colors.red}
      navigationIsSelected={{
        name: Screens.ASE_FIELDS,
        params: { groupId: group.id },
      }}
      onPress={() =>
        navigateScreenAware(Stacks.ASSESSMENT, Screens.ASE_FIELDS, {
          groupId: group.id,
        })
      }
      navigationType={screenSize === ScreenSize.large ? 'screen' : undefined}
      compact={explorerOptionSize === 'small'}
      small={explorerOptionSize === 'small'}
    />
  );
};
